/* Lo que se recuerda de cada serie en este aparato: el audio y los subtítulos que se eligieron (para no volver a elegirlos en
   cada episodio) y la marca de la intro (para poder saltarla aunque el proveedor no dé marcas). Módulo puro: recibe el
   almacenamiento. Las claves son el id de la serie. */

const TRACKS_KEY = 'trackPrefs';
const INTRO_KEY = 'introMarks';
const MAX_SERIES = 300;
const MIN_INTRO_SECS = 5;

const ISO3 = { spa: 'es', esp: 'es', eng: 'en', fre: 'fr', fra: 'fr', ger: 'de', deu: 'de', ita: 'it', por: 'pt', cat: 'ca', jpn: 'ja', kor: 'ko', chi: 'zh', zho: 'zh', rus: 'ru', ara: 'ar' };
const NAMES = { espanol: 'es', castellano: 'es', spanish: 'es', ingles: 'en', english: 'en', frances: 'fr', francais: 'fr', french: 'fr', aleman: 'de', deutsch: 'de', german: 'de', italiano: 'it', italian: 'it', portugues: 'pt', portuguese: 'pt', catala: 'ca', japones: 'ja', japanese: 'ja' };
const plain = (x) => String(x).normalize('NFD').replace(/[\u0300-\u036f]/g, '');

/** «es», «es-ES», «spa», «Español», «Spanish (Latin America)» → «es»; si no se reconoce, el texto en minúsculas. */
export function normLang(x) {
    const s = String(x == null ? '' : x).trim().toLowerCase();
    if (!s) return '';
    const base = plain(s.split(/[-_ (]/)[0]);
    if (/^[a-z]{2}$/.test(base)) return base;
    if (ISO3[base]) return ISO3[base];
    if (NAMES[base]) return NAMES[base];
    return s;
}

/** Idioma de una pista { lang, label }: su código si lo trae y, si no, el que se pueda sacar del nombre. */
export const trackLang = (tr) => normLang(tr && tr.lang) || normLang(tr && tr.label);

/** La pista que corresponde a lo recordado ('es', 'off'…), o null. */
export function findTrack(tracks, wanted) {
    const w = normLang(wanted);
    if (!w || w === 'off') return null;
    return (tracks || []).find((t) => trackLang(t) === w) || null;
}

const read = (storage, key) => { const v = storage.get(key, {}); return v && typeof v === 'object' ? v : {}; };

function prune(map) {
    const keys = Object.keys(map);
    if (keys.length > MAX_SERIES) keys.sort((a, b) => (map[a].updated || 0) - (map[b].updated || 0)).slice(0, keys.length - MAX_SERIES).forEach((k) => { delete map[k]; });
}

export function getTrackPrefs(storage, seriesId) {
    return read(storage, TRACKS_KEY)[String(seriesId)] || null;
}

/** patch: { audio: 'es' } y/o { subs: 'en' | 'off' } */
export function rememberTracks(storage, seriesId, patch, now = Date.now()) {
    const all = read(storage, TRACKS_KEY);
    const k = String(seriesId);
    const clean = {};
    if (patch.audio) clean.audio = normLang(patch.audio);
    if (patch.subs) clean.subs = patch.subs === 'off' ? 'off' : normLang(patch.subs);
    all[k] = Object.assign({}, all[k], clean, { updated: now });
    prune(all);
    storage.set(TRACKS_KEY, all);
}

export function getIntro(storage, seriesId) {
    const m = read(storage, INTRO_KEY)[String(seriesId)];
    return m && m.end - m.start >= MIN_INTRO_SECS ? { start: m.start, end: m.end } : null;
}

/** Guarda la intro de la serie (segundos). Devuelve false si no vale (final antes de inicio o demasiado corta). */
export function setIntro(storage, seriesId, start, end, now = Date.now()) {
    start = Math.max(0, Math.round(Number(start) * 10) / 10);
    end = Math.round(Number(end) * 10) / 10;
    if (!Number.isFinite(start) || !Number.isFinite(end) || end - start < MIN_INTRO_SECS) return false;
    const all = read(storage, INTRO_KEY);
    all[String(seriesId)] = { start, end, updated: now };
    prune(all);
    storage.set(INTRO_KEY, all);
    return true;
}

export function clearIntro(storage, seriesId) {
    const all = read(storage, INTRO_KEY);
    delete all[String(seriesId)];
    storage.set(INTRO_KEY, all);
}
